import React from 'react';
import { useTranslation } from 'react-i18next';
import { preferenceUpdateCerealMixService } from '../../services/preferenceUpdateCerealMixService';
import {PreferenceType} from "../../services/preferenceTypes";
import {preferenceSaveService} from "../../services/preferenceSaveService";
import { Select } from '@chapche/ui';


const PreferenceStructureType = ({ index, parentMode}) => {
    const { i18n } = useTranslation();
    const updatePreferenceValue = (value: PreferenceType) => {
        if(parentMode) {
            preferenceSaveService.updatePreferenceProperty('preferenceType', value);
            if (value === PreferenceType.CEREAL_MIX) {
                preferenceUpdateCerealMixService.changeIngredientType(value);
            }
        } else {
            preferenceSaveService.updateCombinedPreference(index, 'preferenceType', value);
        }
    };
    const findPreferenceValue = (preferenceSaveService, index, parentMode) => {
        if (parentMode === true) {
            return preferenceSaveService.getPreference().preferenceType || '';
        }
        if (index === undefined || !preferenceSaveService.getPreference().combinedPreferences[index].preferenceType) {
            return '';
        }
        return preferenceSaveService.getPreference().combinedPreferences[index].preferenceType;
    };
    const createListOfOptions = (parentMode: boolean) => {
        return  Object.values(PreferenceType).filter(it => {
            if(parentMode === false) {
                return it !== PreferenceType.COMBINATION;
            }
            return true;
        }).map(it => {
            return {
                value: it,
                label: i18n.t(`preference.scheme.preferenceType.${it}`),
            };
        });
    };
    return (
        <label className="block__text preference__form-label">
            <span>{i18n.t('app.page.preference.addTitles.preferenceType')}</span>
            <Select
                fullWidth
                className="mt-0"
                value={findPreferenceValue(preferenceSaveService, index, parentMode)}
                options={createListOfOptions(parentMode)}
                onChange={updatePreferenceValue}
            />
        </label>
    );
};

export default PreferenceStructureType;
